import api from '@pray/shared/utils/api';

export async function getStatementYearlyCounts({ artistId = '' } = {}) {
  const url = `/web/studio/artists/${artistId}/giving-payments/statements/yearly-counts`;
  const response = await api.executeGetRequest(url);

  return response.data;
}
